import React from 'react';

import { Row, Text, Column } from 'farmhub-ui-core';

import { OrderFilledIcon } from 'components/Icon';

import ChooseEmployeePopover from '../ChooseEmployeePopover';
import { IconWrapper, Wrapper } from './styles';

type TaskItemProps = {
  isAssigning: boolean;
  data: any;
  onAssignee: (orderTaskID: string, assigneeID: string) => Promise<void>;
};

const TaskItem = ({ isAssigning, data, onAssignee }: TaskItemProps) => (
  <Wrapper>
    <Row styles={{ gap: 8 }} width="fit-content">
      <IconWrapper active>
        <OrderFilledIcon color="#FFFFFF" height={18} width={18} />
      </IconWrapper>
      <Column>
        <Text color="primary" size="xxs" weight="bold">
          {data.task.name}
        </Text>
      </Column>
    </Row>
    <ChooseEmployeePopover
      assignee={data.assignee}
      isAssigning={isAssigning}
      orderTaskID={data.id}
      onAssignee={onAssignee}
    />
  </Wrapper>
);

export default TaskItem;
